import { CSSProperties, useState } from 'react';
import { connect } from 'react-redux';
import { IDataStorage, Settings } from '../../core';
import { FxTranslate } from '../../core/translate';
import API from '../../services/api';
import { ConfigEstados, Estados, GetStyleEstado } from '../../services/operaciones';
import { CardHelper, ICardEdit } from '../../services/operaciones/model/ICardEdit';
import Alert from '../alerts';
import { Button } from '../prime';
import Question from '../question';
import { MedioPagoEditOut } from '../../model/cobranza';

//import styles from './card-botonera.module.scss';

const CloseCard = (forceRefresh?: boolean) => (window as any).CloseCard(forceRefresh);

const getLinkPago = (t: FxTranslate, card: ICardEdit | null | undefined) => {
  if (!card?.operacion) return '';
  if (card.operacion.estado !== Estados.Pendiente) {
    Alert.info(t("Botonera.Pagar.EstadoInvalido.Title"), t("Botonera.Pagar.EstadoInvalido.Message"))
    return '';
  }

  const model : any = { 
    IdOperacion: card.operacion.id,
    Target: 0, // PagarTarget.Payment = 0,
    Origen: 1, // PagarOrigen.BackOffice = 1,
    IdUsuario: undefined, // Usuario logueado, pero no se usa desde link de pago
    SistemaOrigen: "cnet-bo", // Sistema que genera el link de pago
  };

  return `${Settings().cnet.url}/pagar?q=${btoa(JSON.stringify(model))}`;
} 

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  cardData?: ICardEdit | null | undefined;
  existsUpdates: boolean;
  
  mediospago?: MedioPagoEditOut[] | null | undefined;

  setSaving?: (saving:boolean) => void;
}

function BoardCardFormBotonera({ storage, t,
  cardData, existsUpdates,
  mediospago, setSaving
} : IProps) {
  
  // popups
  const [ question, setQuestion ] = useState<{ title: string, text: string, ok_style?: CSSProperties, ok_text?: string, cancel_text?: string, to: Estados }|undefined>(undefined)
  const [ blockSendEmailButton, setBlockSendEmailButton ] = useState<boolean>(false);

  const onTransitionEstado = (estado: Estados) => {
    setQuestion(undefined);
    return API.OperacionesController().Operacion().estado({ idCotizacion: cardData?.cotizacion?.id, idOperacion: cardData?.operacion?.id, newEstado: estado }).then(res => {
      if (!res.success) return Alert.reponse(res);
      CloseCard(true);
    }).catch((err: unknown) => Alert.error(`${err}`.substring(0, 50), `${err}`))
  }

  const estadoButtons = ConfigEstados.filter(p => p.allow({ card: cardData }, { mediospagos: mediospago ?? [] }));

  const mostrarbotones = {
    recotizar: !cardData?.operacion?.id,
    pagarOP:  !!cardData?.operacion?.id && 
              ((cardData?.operacionvouchers?.length ?? 0) < 1) && 
              (![Estados.Emitir, Estados.Emitido, undefined].includes(CardHelper.estado(cardData))) &&
              !!(cardData?.operacionproducto?.idcalcproducto),
    reenviarVoucher: (cardData?.operacionvouchers?.length ?? 0) > 0 && (![Estados.Emitir, Estados.Emitido, Estados.ErrorEmitiendo, undefined].includes(CardHelper.estado(cardData))),
  }

  return <>
    <div style={{ overflowX: 'auto', width: 'calc(100vw - 200px)' }}>
      <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        {estadoButtons.map(estado => 
          <Button 
            key={estado.id}
            label={t(`@Id.Operacion.Estado#${estado.id}`)}
            style={GetStyleEstado(estado.id)}
            disabled={!!existsUpdates} 
            onClick={() => {
              setQuestion({
                title: t(`Workflow.Transicion.Title.${estado.id}`),
                text: t(`Workflow.Transicion.Text.${estado.id}`),
                ok_style: GetStyleEstado(estado.id),
                ok_text: t(`@Id.Operacion.Estado#${estado.id}`),
                cancel_text: t(`Workflow.Transicion.CancelText`),
                to: estado.id,
              })
            }} 
          />
        )}

        {estadoButtons.length > 0 && ( mostrarbotones.pagarOP || mostrarbotones.recotizar || mostrarbotones.reenviarVoucher) &&
          <i className="pi pi-bars p-toolbar-separator p-mr-2" />
        }        

        {/* RECOTIZAR */}
        {mostrarbotones.recotizar && <>
          <Button 
            label={t("Botonera.Recotizar")}
            className="p-button-outlined p-button-secondary" icon="pi pi-external-link" style={{ marginLeft: 10, marginRight: 0 }} 
            onClick={() => {
              const a = document.createElement("a");
              a.href = `${Settings().cnet.url}/recotizar?q=${btoa(JSON.stringify({ IdCotizacion: cardData?.cotizacion.id}))}`;
              a.target = "_blank";
              a.click();
            }}
          />
          <Button 
            className="p-button-outlined p-button-secondary" icon="pi pi-copy" style={{ width: 40 }}
            onClick={() => navigator.clipboard.writeText(`${Settings().cnet.url}/recotizar?q=${btoa(JSON.stringify({ IdCotizacion: cardData?.cotizacion.id}))}`)}
          />
        </>}

        {/* PAGAR COTIZACION U OPERACION */}
        {mostrarbotones.pagarOP && <>
          <Button 
            label={t("Botonera.Pagar")}
            className="p-button-outlined p-button-secondary" icon="pi pi-external-link" style={{ marginLeft: 10, marginRight: 0 }} 
            onClick={() => {
              const url = getLinkPago(t, cardData);
              if (!url || url.length < 1) return;
              const a = document.createElement("a");
              a.href = url;
              a.target = "_blank";
              a.click();
            }}
          />
          <Button 
            className="p-button-outlined p-button-secondary" icon="pi pi-copy" style={{ width: 40 }}
            onClick={() => navigator.clipboard.writeText(getLinkPago(t, cardData))}
          />
        </>}
        
        {/* REENVIAR EMAIL DE VOUCHERS */}
        {mostrarbotones.reenviarVoucher &&
          <Button 
            label={t("Botonera.ResendEmail")} 
            className="p-button p-button-secondary" icon="fas fa-envelope" style={{ marginLeft: 10 }} 
            onClick={() => {
              setSaving && setSaving(true);
              API.OperacionesController().Voucher().SendEmail(cardData?.operacion?.id)
                .finally(() => setSaving && setSaving(false));
              setBlockSendEmailButton(true);
            }}
            disabled={!!blockSendEmailButton}
          />
        }
      </div>
      <Question
        visible={!!question}
        title={question?.title??''}
        text={question?.text??''}
        ok_style={question?.ok_style}
        ok_text={question?.ok_text}
        cancel_text={question?.cancel_text}
        onClose={() => setQuestion(undefined)}
        ok={() => {
          setSaving && setSaving(true);
          onTransitionEstado(question!.to).finally(() => {
            setSaving && setSaving(false);
          });
        }}
      />
    </div>
  </>;
}

export default connect((s:any) => ({ storage:s.main }))(BoardCardFormBotonera);
